import { a as isContextError, c as logCtxParent, d as withPrefix, f as Logger, i as getCtx, l as TestLogger, n as LOG_LEVEL, o as joinContextsIfDefined, r as LogLevelProvider, s as logCtxItem, t as LogWriter, u as NullLogger } from "./log_writer-6NTRwqhf.mjs";
import { Injectable } from "@gitlab/needle";
import dayjs from "dayjs";
//#region src/default_logger.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const LOG_LEVEL_MAPPING = {
	[LOG_LEVEL.ERROR]: 1,
	[LOG_LEVEL.WARNING]: 2,
	[LOG_LEVEL.INFO]: 3,
	[LOG_LEVEL.DEBUG]: 4
};
const getNumericMapping = (logLevel) => {
	if (logLevel && logLevel in LOG_LEVEL_MAPPING) return LOG_LEVEL_MAPPING[logLevel];
	return LOG_LEVEL_MAPPING[LOG_LEVEL.INFO];
};
const PADDING = 4;
const ensureError = (e) => {
	if (e instanceof Error) return e;
	if (typeof e === "string") return new Error(e);
	if (e === void 0 || e === null) return;
	try {
		return new Error(JSON.stringify(e));
	} catch {
		return;
	}
};
const printCtxNode = (node, depth = 0) => {
	const indent = (padding) => "  ".repeat(padding);
	let result = `${indent(depth)}- ${node.name}:`;
	if (node.value !== void 0) result += ` ${node.value}`;
	result += "\n";
	if (node.children) for (const child of node.children) result += printCtxNode(child, depth + 1);
	return result;
};
const printCtx = (ctx) => {
	return printCtxNode(ctx).trim();
};
let _DefaultLogger;
(class {
	static {
		[_DefaultLogger, _initClass] = _applyDecs(this, [Injectable(Logger, [LogWriter, LogLevelProvider])], []).c;
	}
	#logWriter;
	#logLevelProvider;
	#ctx;
	constructor(logWriter, logLevelProvider) {
		this.#logWriter = logWriter;
		this.#logLevelProvider = logLevelProvider;
	}
	/**
	* @param messageOrError can be error (if we don't want to provide any additional info), or a string message
	* @param trailingError is an optional error (if messageOrError was a message)
	*           but we also mention `unknown` type because JS doesn't guarantee that in `catch(e)`,
	*           the `e` is an `Error`, it can be anything.
	* */
	#log(incomingLogLevel, messageOrError, trailingError) {
		const configuredLevel = this.#logLevelProvider.logLevel;
		if (getNumericMapping(configuredLevel) >= LOG_LEVEL_MAPPING[incomingLogLevel]) this.#logWithLevel(incomingLogLevel, messageOrError, ensureError(trailingError));
	}
	#logWithLevel(level, a1, a2) {
		const formatError = (e) => `${e.stack ?? e.message}`;
		const ctxText = (error) => {
			const ctx = joinContextsIfDefined("Full Context", this.#ctx, getCtx(error));
			return ctx ? `\n${printCtx(ctx)}` : "";
		};
		if (typeof a1 === "string") {
			const errorText = a2 ? `\n${formatError(a2)}` : "";
			this.#multilineLog(`${a1}${errorText}${ctxText(a2)}`, level);
		} else {
			const err = ensureError(a1);
			if (!err) return;
			this.#multilineLog(`${formatError(err)}${ctxText(a1)}`, level);
		}
	}
	#multilineLog(line, level) {
		const prefix = `${dayjs().format("YYYY-MM-DDTHH:mm:ss:SSS")} [${level}]: `;
		const padNextLines = (text) => text.replace(/\n/g, `\n${" ".repeat(PADDING)}`);
		this.#logWriter.write(`${prefix}${padNextLines(line)}`);
	}
	setContext(ctx) {
		this.#ctx = ctx;
	}
	debug(messageOrError, trailingError) {
		this.#log(LOG_LEVEL.DEBUG, messageOrError, trailingError);
	}
	info(messageOrError, trailingError) {
		this.#log(LOG_LEVEL.INFO, messageOrError, trailingError);
	}
	warn(messageOrError, trailingError) {
		this.#log(LOG_LEVEL.WARNING, messageOrError, trailingError);
	}
	error(messageOrError, trailingError) {
		this.#log(LOG_LEVEL.ERROR, messageOrError, trailingError);
	}
	withContext(ctx) {
		const newLog = new _DefaultLogger(this.#logWriter, this.#logLevelProvider);
		newLog.setContext(ctx);
		return newLog;
	}
	static {
		_initClass();
	}
});
//#endregion
export { _DefaultLogger as DefaultLogger, LOG_LEVEL, LogLevelProvider, LogWriter, Logger, NullLogger, TestLogger, getCtx, isContextError, joinContextsIfDefined, logCtxItem, logCtxParent, withPrefix };

//# sourceMappingURL=index.mjs.map